import { Button } from "@sellar-io/components";
import { ReactElement } from "react";
import {
  Dialog,
  DialogNavigation,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { useEvents } from "../../../hooks";
import { useOrderCardPaymentWithDepositRemainingBalancePaidManually } from "../../../hooks/api/v2/order/useOrderCardPaymentWithDepositRemainingBalancePaidManually";

export function CardPaymentWithDepositManualPaymentModal({
  active,
  onDismiss,
  orderId,
}: {
  active: boolean;
  onDismiss: () => void;
  orderId: number;
}): ReactElement {
  const { track } = useEvents();

  const mutation =
    useOrderCardPaymentWithDepositRemainingBalancePaidManually(orderId);

  const onConfirm = async () => {
    const paidAt = new Date();
    mutation.mutate(undefined, {
      onSuccess: () => {
        track("Order Remaining Balance Marked As Paid Manually", {
          initiator: "supplier",
          orderId: orderId,
          paidAt,
        });
        onDismiss();
      },
    });
  };

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title="Record manual payment"
        description="Only continue if you've received the remaining balance for this order outside of Sellar (e.g. bank transfer). This will mark the order as paid and cannot be undone."
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={onDismiss}
      />
      <DialogCTA>
        <Button onClick={onConfirm} loading={mutation.isPending}>
          Order paid
        </Button>
      </DialogCTA>
    </Dialog>
  );
}
